/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The role of a team member.
 */
export enum TeamMemberRole {
    MEMBER = 'Member',
    ADMIN = 'Admin',
    LEADER = 'Leader',
}
